// extracted by mini-css-extract-plugin
module.exports = {"head":"e_ce","title":"e_de","thumb":"e_ee","titleText":"e_fe","h1":"e_ge","facts":"e_he"};